<!-- APP内嵌投顾用 - 个人主页  -->
<template>
    <div>
        <loading-dom v-if="isShowLoading" style="position: fixed; z-index: 999999;"></loading-dom>
        <div class="recommend">
        <div>
            <div class="user_profiles_header">
                <div :class="['header_bg', {
                    is_show_cert_no
                }]">
                    <div class="header_bg_img">
                        <img :src="backgroundImg" alt="">
                        <div class="transparent_box"></div>
                    </div>
                </div>
                <div class="login_box login_box_vip_top" >

                    <img 
                        v-if="userInfo.serve_vip_top_text"
                        :src="userInfo.serve_vip_top_text"
                        :style="imageStyle" 
                     />

                </div>
                <dl class="user_profiles_top">
                    <dt class="user_image" @click.stop.prevent="viewAvatar">
                        <img :src="userInfo.image" alt="" />
                    </dt>
                    <dd class="user_operation">
                        <div class="user_title">
                            <h3
                                class="user_name"
                                @click.stop.prevent="nickInfoType = true;"
                            >{{ userInfo.remark_name || userInfo.title }}</h3>
                            <div class="nickInfoWrap" v-if="nickInfoType">
                                <div class="nickInfoWrapBg" @click.stop.prevent="nickInfoType = false;" @touchmove.stop.prevent ></div>
                                <div class="nickInfoWrapBox">
                                    <svg width="15" height="8" viewBox="0 0 15 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M6.60175 1.23666C6.99413 0.83467 7.64057 0.834669 8.03296 1.23666L14.6347 8.00001H0L6.60175 1.23666Z" fill="white"/>
                                    </svg>
                                    <ul>
                                        <li @click.stop.prevent="nickInfoFn('copy_nickname', userInfo.remark_name || userInfo.title)">复制昵称</li>
                                        <li @click.stop.prevent="nickInfoFn('set_remark')">设置备注</li>
                                        <li @click.stop.prevent="nickInfoFn('detail_share')">分享</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="user_ip_info">
                            <div v-if="false" class="user_ip">IP属地：北京AA</div>
                            <span v-if="false"></span>
                            <div class="user_more_info" v-if="false" @click.stop.prevent="openNative('personal_detail')">更多信息</div>
                            
                            <div class="user_icons">
                                <!-- 徽章 -->
                                <div
                                    v-for="(item, index) in user_medals_tail"
                                    :key="index"
                                    class="user_authentication_item"
                                    :style="{
                                        backgroundImage: 'url(' + item.image + ')'
                                    }"
                                >
                                    <span>{{item.title}}</span>
                                </div>
            
                                <!-- 展开收起 -->
                                <div v-if="userInfo.serve_vip == 'yes' && userInfo.is_open_vip_buy == 'yes' && userInfo.video_teacher == '0' && !isSelf" :class="['user_open_list', {
                                        fz: is_show_cert_no
                                    }]" @click.stop.prevent="is_show_cert_no = !is_show_cert_no"></div>
                            </div>
                        </div>
                    </dd>

                    <!-- 购买VIP tips -->
                    <div :class="['open_vip_btn', {
                            is_vip: is_vip == 'yes'
                        }]"
                        v-if="userInfo.serve_vip == 'yes' && userInfo.is_open_vip_buy == 'yes' && userInfo.video_teacher == '0' && !isSelf"
                        @click.stop.prevent="openNative('vip_product')">
                        <span>{{is_vip == 'yes'? '已开通': '开通会员'}}</span>
                        <!-- 活动 tips -->
                        <div class="open_vip_btn_activity"
                            v-if="userInfo && userInfo.activity && (userInfo.activity.gold_coin_info && userInfo.activity.gold_coin_info != '' || userInfo.activity.info && userInfo.activity.info != '')">
                            <span>{{userInfo.activity.gold_coin_info || userInfo.activity.info}}</span>
                            <svg width="7" height="5" viewBox="0 0 7 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                    d="M0.75 0.5V4C0.75 4.61511 1.4497 4.96867 1.9449 4.60379L6.6949 1.10379C6.90917 0.945905 7.00362 0.721136 7.00141 0.5H6.25L1.5 4V0.5H0.75Z"
                                    fill="white" />
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M1.5 0.5V4L6.25 0.5H1.5Z"
                                    fill="#FF892C" />
                            </svg>
                        </div>
                    </div>

                    <!-- 设置背景 -->
                    <div class="setBgIcon" v-if="change_bgImg == 'yes' && isSelf"
                        @click.stop.prevent="openNative('edit_background_image')">

                    </div>
                </dl>

                <!-- 挪了一下位置哈 -->
                <div class="user_icons" v-if="false">
                    <!-- 性别 - 投顾貌似不显示性别嗷 -->

                    <!-- 等级 -->
                    <div class="user_lv_icon" v-if="false">Lv.{{userInfo.level}}</div>

                    <!-- 徽章 -->
                    <div
                        v-for="(item, index) in user_medals_tail"
                        :key="index"
                        class="user_authentication_item"
                        :style="{
                            backgroundImage: 'url(' + item.image + ')'
                        }"
                        @click.stop.prevent="openNative('medal_page')"
                    >
                        <span>{{item.title}}</span>
                    </div>

                    <!-- 展开收起 -->
                    <div v-if="is_vip == 'yes'" :class="['user_open_list', {
                            fz: is_show_cert_no
                        }]" @click.stop.prevent="is_show_cert_no = !is_show_cert_no"></div>
                </div>

                <!-- 模拟炒股冠军徽章列表 -->
                <div class="user_badge">
                    <div v-for="(item, index) in userInfo.medal_list" :key="index" :style="{
                            backgroundImage: 'url(' + item.image + ')'
                        }" @click.stop.prevent="openNative('match_page')">{{item.title}}<i></i></div>
                </div>

                <!-- 证书 is_vip -->
                <!-- @click.stop.prevent="openNative('personal_detail')" -->
                <div class="user_certificat" v-show="is_show_cert_no">
                    <p>证书：{{userInfo.cert_no}}
                        <span v-if="0 && is_vip == 'no'"
                            @click.stop.prevent="openNative('vip_product')">开通会员查看完整资料</span>
                    </p>
                </div>

                <div class="user_certificat user_certificat2" v-show="is_show_cert_no && userInfo.service_phone">
                    <p>客服电话：{{userInfo.service_phone}}</p>
                </div>

                

                <!-- 简介 -->
                <div :class="['user_brief', {
                        showMargin: !is_show_cert_no
                    }]">
                    <div class="user_brief_left">简介：</div>
                    <div class="user_brief_right">
                        <p v-html="introWithAtUser"></p>
                    </div>
                </div>

                <!-- 风格 -->
                <div class="tag_list" v-if="userInfo && userInfo.tag_list && userInfo.tag_list.length > 0">
                    <div class="tag_list_left">风格：</div>
                    <div class="tag_list_right">{{ tagFn }}</div>
                </div>

                <!-- 内容数量 = 关注 - 私信 -->
                <div class="blockdiv">
                    <div class="blockdivLeft">
                        <dl>
                            <dt>{{userInfo_num.publish}}</dt>
                            <dd>贴子</dd>
                        </dl>
                        <dl @click.stop.prevent="openNative('fans_page')">
                            <dt>{{userInfo_num.fans}}</dt>
                            <dd>人气</dd>
                        </dl>
                        <dl @click.stop.prevent="openNative('follow_page')">
                            <dt>{{userInfo_num.follow}}</dt>
                            <dd>关注</dd>
                        </dl>
                        <dl>
                            <dt>{{userInfo_num.praise}}</dt>
                            <dd>获赞</dd>
                        </dl>
                    </div>

                    <!-- 不是本人的样式 -->
                    <div class="blockdivRight" v-if="!isSelf">
                        <!-- 关注 -->
                        <button :class="['blockdivFollow', {
                                // 特别关注
                                is_special: userInfo.is_follow != 'no' && userInfo.is_special == 'yes',
                                // 普通关注
                                is_follow: userInfo.is_follow != 'no' && userInfo.is_special != 'yes',
                                // 未关注
                                is_no_follow: userInfo.is_follow == 'no',
                                // 没有私信的情况下（这样就左边一个样式了
                                is_only: userInfo.can_letter != 'yes'
                            }]" @click.stop.prevent="followUserFn">
                            {{ userInfo.is_follow != 'no'? (userInfo.is_special == 'yes'? '特别关注': '已关注'): '关注' }}
                        </button>

                        <!-- 私信 -->
                        <button
                            v-if="userInfo.can_letter == 'yes'"
                            class="blockdivMsg"
                            @click.stop.prevent="openNative('direct_msg')"
                        >私信</button>
                    </div>

                    <!-- 如果是本人查看 -->
                    <div class="blockdivRight" v-else-if="isSelf">
                        <!-- 编辑资料 -->
                        <button class="blockdivEdit"
                            @click.stop.prevent="openNative('edit_personal_info')">编辑资料</button>
                    </div>
                </div>

                <!-- 视频直播预约  1||-->
                <div
                    class="liveInfoBox"
                    v-if="(previewInfoo && previewInfoo.id)"
                    @click.stop.prevent="openNative('detail_page', {
                        o_kind: previewInfoo.kind,
                        id: previewInfoo.id,
                        name: previewInfoo.title,
                        query: previewInfoo
                    })"
                >
                    <div class="liveInfoTitle">视频直播预约</div>
                    <div class="liveInfoContent">{{previewInfoo.content}}</div>
                    <span></span>
                </div>

                <!-- 顶部圆角布局 -->
                <div class="top_radius_div">
                    <div></div>
                </div>
            </div>

            <!-- 此页面由XX提供 -->
            <div class="user_profiles_tabs_page" v-if="zxTips">
                <div>
                    <p>此页面由中讯证券提供&nbsp;&nbsp;www.aigupiao.com</p>
                    <button @click.stop.prevent="closeZXTip"></button>
                </div>
            </div>

            <!-- 拉黑样式 1|| -->
            <template v-if="(userInfo.is_black == 1)">
                <div class="black_wrap">
                    <div class="black_icon"></div>
                    <div class="black_content">你已将对方拉黑，无法查看其主页内容</div>
                </div>
                <button class="black_btn" @click.stop.prevent="removeBlackFn">解除黑名单</button>
            </template>

            <!-- 横向滚动条 -->
            <div class="user_stock_list" v-show="profitsInfo || matchInfo">
                <div v-if="profitsInfo || matchInfo" :class="[{
                        hasOnly: !initBtmLine
                    }]">
                    <div class="user_stock_list_wrap" ref="user_stock_list_rf">
                        <div class="swiper2 tab2">
                            <div class="swiper-container">
                                <div class="swiper-wrapper" style="display: flex;">
                                    <!-- 模拟炒股大赛 - 卡片 -->
                                    <div class="swiper-slide match_stock_wrap" v-if="matchInfo"
                                        @click.stop.prevent="openNative('match_detail_page')">
                                        <div
                                            :class="['match_stock_left', isGoUp(matchInfo.profit_rate) ? 'to_red' : 'to_green']">
                                            <p class="match_stock_price">{{ matchInfo.profit_rate }}%</p>
                                            <p class="match_stock_txt">总收益</p>
                                        </div>
                                        <div class="match_stock_left_info">
                                            <p class="match_stock_name">{{ matchInfo.g_name }}<span>炒股大赛</span></p>
                                            <p class="match_stock_content">{{ matchInfo.max_stock_position_name }}</p>
                                        </div>
                                    </div>

                                    <!-- 模拟组合 - 卡片 -->
                                    <div
                                        class="swiper-slide user_stock_wrap"
                                        v-if="profitsInfo"
                                        @click.stop.prevent="openNative('group_detail_page')"
                                    >
                                        <div
                                            :class="['user_stock_left', isGoUp(profitsInfo.profit_rate) ? 'to_red' : 'to_green']">
                                            <p class="user_stock_price">{{ profitsInfo.profit_rate }}%</p>
                                            <p class="user_stock_txt">总收益</p>
                                        </div>
                                        <div class="user_stock_left_info">
                                            <p class="user_stock_name">{{ profitsInfo.g_name }}</p>
                                            <p class="user_stock_content">{{ profitsInfo.max_stock_position_name }}</p>
                                        </div>
                                        <div class="user_stock_right">
                                            <button
                                                v-if="!isSelf"
                                                :class="['user_stock_follow', {
                                                    is_follow: profitsInfo.is_follow == 'yes'
                                                }]"
                                                @click.stop.prevent="followGroup"
                                            >{{ profitsInfo.is_follow == 'yes' ? '已订阅' : '订阅' }}</button>
                                            <div v-else class="user_stock_menu">
                                                <button
                                                    class="user_stock_tc"
                                                    @click.stop.prevent="openNative('group_transfer_warehousee')"
                                                >调仓</button>
                                                <button
                                                    class="user_stock_set"
                                                    @click.stop.prevent="openNative('group_setting_page')"
                                                ></button>
                                            </div>
                                            <p>{{ profitsInfo.follow_num }}人订阅&nbsp;{{ isSelf ? (profitsInfo.show_zh == '1'? '公开': '隐藏'): '' }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="user_stock_list_line" v-if="profitsInfo && matchInfo && initBtmLine && false">
                    <div><span :style="{
                        left: profitsMatchStockLeft + '%',
                        width: initBtmLineWidth + '%'
                    }"></span></div>
                </div>
            </div>

            <!-- 点击关注用户弹出来的 推荐关注用户卡片 1||-->
            <collapse-transition>
                <FollowUserCard v-if="(showFollowCard)"></FollowUserCard>
            </collapse-transition>

            <div class="user_profiles_tabs" v-if="userInfo.is_black != 1">
                <div class="user_profiles_tab_box">
                    <div class="user_profiles_tab" ref="user_profiles_tab_RF">
                        <!-- 搜索 -->
                        <div class="serach_btn" v-if="false">
                            <button @click.stop.prevent="openNative('search_page')"></button>
                        </div>
                        <van-tabs
                            @scroll="handleScrollTab"
                            :before-change="handleClickTab"
                            animated
                            sticky
                        >
                            <slot slot="nav-right">
                                <!--搜索 -->
                                <div class="serach_btn">
                                    <button @click.stop.prevent="openNative('search_page')"></button>
                                </div>
                            </slot>
                            <van-tab
								v-for="(item) in tagsList"
								:key="item.name"
								:title="item.title"
								:name="item.name"
							>

                                <div class="tabs-content">
                                    <!-- 全部 -->
                                    <tabs-all
                                        ref="TabsMsg"
                                        pageName="message"
                                        v-if="item.name === 'TabsMsg'"
                                        :pageType="pageType"
                                        :teacherInfo="userInfo"
                                        :liverNoticeList="liverNoticeAll"
                                        :liveCardInfo="liveCardInfo"
                                        :isSelf="isSelf"
                                        :apptextSize="apptextSize"
                                    ></tabs-all>

                                    <!-- 会员 -->
                                    <tabs-vip
                                        ref="TabsVip"
                                        pageName="vip_message"
                                        v-if="item.name === 'TabsVip'"
                                        :pageType="pageType"
                                        :teacherInfo="userInfo"
                                        :liveCardInfo="liveCardInfo"
                                        :isSelf="isSelf"
                                        :apptextSize="apptextSize"
                                    ></tabs-vip>

                                    <!-- 专栏 -->
                                    <tabs-news
                                        ref="TabsNews"
                                        pageName="charge"
                                        v-if="item.name === 'TabsNews'"
                                        :pageType="pageType"
                                        :teacherInfo="userInfo"
                                        :liveCardInfo="liveCardInfo"
                                        :isSelf="isSelf"
                                        :apptextSize="apptextSize"
                                    ></tabs-news>

                                    <!-- 精华 -->
                                    <tabs-essence
                                        ref="TabsEssence"
                                        pageName="charge_best"
                                        v-if="item.name === 'TabsEssence'"
                                        :pageType="pageType"
                                        :teacherInfo="userInfo"
                                        :liverNoticeList="liverNoticeEssence"
                                        :liveCardInfo="liveCardInfo"
                                        :isSelf="isSelf"
                                        :apptextSize="apptextSize"
                                    ></tabs-essence>

                                    <!-- 视频 -->
                                    <tabs-video
                                        ref="TabsVideo"
                                        pageName="video"
                                        v-if="item.name === 'TabsVideo'"
                                        :pageType="pageType"
                                        :teacherInfo="userInfo"
                                        :isSelf="isSelf"
                                        :apptextSize="apptextSize"
                                    ></tabs-video>

                                    <tabs-chatting-room
                                        ref="TabsChattingRoom"
                                        pageName="chattingRoom"
                                        v-if="item.name === 'TabsChattingRoom'"
                                        :pageType="pageType"
                                        :teacherInfo="userInfo"
                                        :isSelf="isSelf"
                                        :apptextSize="apptextSize"
                                    ></tabs-chatting-room>

                                    <!-- 组合 -->
                                    <tabs-combination
                                        ref="TabsCombination"
                                        pageName="stock_select"
                                        v-if="item.name === 'TabsCombination'"
                                        :pageType="pageType"
                                        :teacherInfo="userInfo"
                                        :isSelf="isSelf"
                                        :apptextSize="apptextSize"
										:list="stockList"
                                    ></tabs-combination>
                                </div>
                            </van-tab>
                        </van-tabs>
                    </div>
                </div>
            </div>
        </div>

        <!-- 加载中样式 -->
        <div class="loading_pop" v-if="!Object.keys(userInfo).length">
            <img :src="require('@/assets/images/loading.svg')" />
        </div>

        <!-- 回到顶部 -->
        <div class="scrollGoTop" v-show="isGoTop == 'yes'">
            <button @click.stop.prevent="goTop"></button>
        </div>
        
        <!-- signToastDom -->
        <sign-toast-dom
            v-if="isShowSignCard"
            :url="isShowSignUri"
        ></sign-toast-dom>

        <!-- userMToastDom -->
        <user-m-toast-dom
            v-if="isShowSatiCard"
            :url="isShowSatiUri"
        ></user-m-toast-dom>
        </div>
    </div>

</template>
<script>
import { u_id, appversion, source, change_bgImg, textSize } from "@/utils/urlQuery";
import { scrollLoad, scrollLoadGoTop, isGoUp, isLoginInfo, reSetUrl, highLightAtUser } from "@/utils/index";

import Swiper from "swiper";
import { Tab, Tabs, Toast, Dialog } from "vant";
import "@/utils/flexible";
// import 'lib-flexible/flexible.js'

// import * as NumApi from "@/api/userNum/index.js";
import userHomeApi from "@/api/user_home/index.js";

export default {
    name: "user_home",
    components: {
        loadingDom: ()=> import("@/page/app/page_loading.vue"),

        TabsAll:() => import('@/components/userHome/TabAll'), // 全部
        TabsNews: () => import("@/components/userHome/TabNews"), // 专栏
        TabsEssence: () => import("@/components/userHome/TabEssence"), // 精华
        TabsVideo: () => import("@/components/userHome/TabVideo"), // 视频
        TabsCombination: () => import("@/components/userHome/TabCombination"),
        TabsChattingRoom: () => import("@/components/userHome/TabChattingRoom"), // 聊天室 - 未购买
        TabsVip: () => import("@/components/userHome/TabVip"), // 会员
        signToastDom: () => import("@/components/signToast.vue"),
        userMToastDom: () => import("@/components/user_m_toast.vue"),
        [Tab.name]: Tab,
        [Tabs.name]: Tabs,
        FollowUserCard: () => import("@/components/userHome/followUserCard.vue"), // 点击关注用户弹出来的卡片
        'collapse-transition': () => import("@/utils/collapse-transition"), // 推荐关注用户的外侧标签-主要是实现了展开收起的特效
    },

    data() {
        return {
            u_id, // 用户ID
            change_bgImg, 
            pageType: "teacher",
            userInfo: {}, //用户基础资料
            tagsList: [], //个人主页tag数据
            tabName: "TabsMsg",
            user_id: parseInt(this.$route.query.id) || 0,
            l_id: parseInt(this.$route.query.l_id) || 0,
            hasMore: false,
            listLoading: true,
            page: 1,
            userInfo_num: {
                publish: 0,//发布
                follow: 0,//关注
                praise: 0,//获赞
                fans: 0,//粉丝，人气
            },//用户的统计数据资料

            user_medals_tail: [], // 用户徽章

            backgroundImg: "", // 当前的背景图

            // 是否展示证书
            is_show_cert_no: false,

            // 是否是会员
            is_vip: 'no',

            // 直播预告信息
            previewInfoo: null,

            // 持仓信息
            profitsInfo: null,

            // 炒股大赛信息
            matchInfo: null,

            // 模拟炒股模块左侧距离
            profitsMatchStockLeft: 0,
            pageClientWidth: 0, // 当前屏幕的宽度
            initBtmLine: false,
            initBtmLineWidth: 0,

            // 战绩榜
            liverNoticeAll: [],    // 全部
            liverNoticeEssence: [], // 精华

            //是否展开关注卡片
            showFollowCard: false,

            // 直播卡片信息
            liveCardInfo: null, 

            // 是否吸顶
            isFixed: false,

            // 是否是本人
            isSelf: false,

            // 是否出现回到顶部样式
            isGoTop: 'no',

            // 中讯弹窗
            zxTips: false,  // 暂时关闭

            swiper2: null, // 轮波 - 两个组合卡片

            loading: false, // 接口加载中

            apptextSize: textSize,
			
			stockList: [], // 自选股

            chatInfo: null,

            nickInfoType: false,
            
            isShowSignCard: false, // 是否展示去签约的弹窗
            isShowSignUri: "",

            isShowSatiCard: false,
            isShowSatiUri: "",

            isShowLoading:true,
            imageStyle:{},

        };
    },
    watch: {
        isFixed (newVal, oldVal) {
            this.$srH5CallNativeMethodApp('call_is_fixed',{
                isFixed: newVal
            })
        },
        userInfo: {
            handler(newVal, oldVal) {
                this.$srH5CallNativeMethodApp('notice_live_details', newVal)
            },
            deep: true//监听父组件数据变化
        } 
    },
    created() {

        // 获取用户信息
        setTimeout(() => {
            this.isShowLoading = false;
        }, 1000);
        this.getUserInfo();

    },
    mounted() {
        let _this = this;
        this.listenScrollFn();

        this.pageClientWidth = document.body.clientWidth;

        $("body").on("click", '.p-a-link', function(e) {
            console.info("CLICK")
            e.stopPropagation();
            e.preventDefault();
            let type = $(this).attr('data-type'), id = $(this).attr('data-id'), name = $(this).attr('data-name'), code = $(this).attr('data-code')
            let query = {}, state = ""
            if(type == 'stock') {
                query.name = name;
                query.code = code;
                state = 'stock_page';
            } else if(type == 'theme') {
                query.id = id;
                state = 'theme_page';
            } else if(type == 'at_user') {
                let role = $(this).attr('data-role');
                state = 'person_page';
                query.o_kind = role;
                query.id = id;
            }
            _this.openNative(state, query)
        })

        $("body").on("click", '.p-url-link', function(e) {
            e.stopPropagation();
            e.preventDefault();
            let url = $(this).attr('url');
            // followup_url
            _this.$srH5CallNativeMethodApp('navigateToAppScheme', {
                url: url
            })
        })

        window.srNativeCallH5Method = (data) => {
            let params = null;
            params = handleSpecialCharacters(data);
            let obj = {};
            if(params && params.params) {
                obj = params.params;
            }


            // 取消关注的回调
            if(params.method_name == 'cancel_follow_method'){
                if(obj.is_follow == 'no') {
                    // 关闭蒙层
                    _this.showFollowCard = false;
                } else {
                    _this.showFollowCard = true;
                }

                if(obj.is_special == 'yes') {
                    _this.showFollowCard = true;
                }
                
                _this.$set(_this.userInfo, 'is_follow', obj.is_follow);
                _this.$set(_this.userInfo, 'is_special', obj.is_special);
                _this.$forceUpdate();
            }

            // 修改头像
            if(params.method_name == "call_edit_user_image") {
                _this.$set(_this.userInfo, "image", obj.img_url);
            }

            // 修改背景图片  
            if(params.method_name == "call_edit_avatar_btn") {
                _this.backgroundImg = obj.img_url;
            }

            // 下拉刷新
            if(params.method_name == "reload_page_list") {
                let tabName = _this.tabName;
                if(obj.tab_name) {
                    switch(obj.tab_name) {
                        case "message":
                            tabName = "TabsMsg"
                            break;
                        case "vip_message":
                            tabName = "TabsVip"
                            break;
                        case "charge":
                            tabName = "TabsNews"
                            break;
                        case "charge_best":
                            tabName = "TabsEssence"
                            break;
                        case "video":
                            tabName = "TabsVideo"
                            break;
                        case "stock_select":
                            tabName = "TabsCombination"
                            break;
                    }
                }

                let rfDom = _this.$refs[tabName];
                if(rfDom && rfDom.length > 0) {
                    rfDom = rfDom[0];
                    rfDom.reloadList && rfDom.reloadList();
                }

                // 更新列表
                if(obj.reload_user_info == 'yes') {
                    _this.getUserInfo('reloadInfo')
                }

                // 刷新用户信息
                if(obj.init_user_info == 'yes') {
                    _this.getUserInfo()
                }

                // 是否回到顶部
                if(obj.is_fixed_top == 'yes') {
                    _this.goTop();
                }
            }

            // 更新 列表
            if(params.method_name == 'edit_item') {
                /*
                    method_name: "edit_item",
                    params: {
                        itemIndex: 1,   // 下标
                        itemId: "",     // ID
                        query: {        // 更改值
                            name: "123",
                            content: "456"
                        }
                    }
                */
                let rfDom = _this.$refs[_this.tabName];
                if(rfDom && rfDom.length > 0) {
                    rfDom = rfDom[0];

                    if(obj.itemId > 0) {
                        let Index = $(".appLiveList" + obj.itemId).attr('data-index')
                        obj.itemIndex = Index * 1;
                    }
                    rfDom.editItemFn && rfDom.editItemFn(obj);
                }
            }

            // 删除
            if(params.method_name == 'del_item') {
                // obj.index 
                /*
                    method_name: "del_item",
                    params: {
                        itemIndex: 1, // 下标
                        itemId: "",     // ID
                    }
                */
                let rfDom = _this.$refs[_this.tabName];
                if(rfDom && rfDom.length > 0) {
                    rfDom = rfDom[0];

                    if(obj.itemId > 0) {
                        let Index = $(".appLiveList" + obj.itemId).attr('data-index')
                        obj.itemIndex = Index * 1;
                    }
                    rfDom.delItemFn && rfDom.delItemFn(obj);
                }
            }

            // 更新RSA vip数据
            if(params.method_name == "decrypt_rsa_content") {
                let rfDom = _this.$refs[_this.tabName], keyname = "";
                switch(_this.tabName) {
                    case "TabsMsg": keyname = "message";break;
                    case "TabsVip": keyname = "vip_message";break;
                    case "TabsNews": keyname = "charge";break;
                    case "TabsEssence": keyname = "charge_best";break;
                    case "TabsVideo": keyname = "video";break;
                    case "TabsChattingRoom": keyname = "chattingRoom";break;
                    case "TabsCombination": keyname = "stock_select";break;
                }
                if(rfDom && rfDom.length > 0) {
                    rfDom = rfDom[0];

                    for(let item in obj) {
                        let key = item, is_forward = false;
                        if(item.indexOf('_') > -1) {
                            key = item.split("_")[0];
                            is_forward = true;
                        }
                        
                        let Index = $(".appLiveList_" + keyname + ".appLiveList" + key).attr('data-index');
                        let itemInfo = {};
                        itemInfo.itemIndex = Index;
                        itemInfo.isForward = is_forward;
                        itemInfo.content = obj[item];

                        rfDom.editRSAStr && rfDom.editRSAStr(itemInfo);
                    }
                }
            }
			
			// 設置字號
            if(params.method_name == 'set_font_size') {
                _this.apptextSize = obj.font_size;
            }
			
			// 更新頁面數據
			if(params.method_name == "call_login_info")  {
				let url = reSetUrl(obj);
				window.history.replaceState(null, null, url);
				window.location.reload(true);
			}
        };

        window.srNativeRsaContent = (content, id) => {
            let rfDom = _this.$refs[_this.tabName], keyname = "";
            switch(_this.tabName) {
                case "TabsMsg": keyname = "message";break;
                case "TabsVip": keyname = "vip_message";break;
                case "TabsNews": keyname = "charge";break;
                case "TabsEssence": keyname = "charge_best";break;
                case "TabsVideo": keyname = "video";break;
                case "TabsChattingRoom": keyname = "chattingRoom";break;
                case "TabsCombination": keyname = "stock_select";break;
            }
            if(rfDom && rfDom.length > 0) {
                rfDom = rfDom[0];

                let key = id, is_forward = false;
                if(id.indexOf('_') > -1) {
                    key = id.split("_")[0];
                    is_forward = true;
                }
                
                let Index = $(".appLiveList_" + keyname + ".appLiveList" + key).attr('data-index');
                let itemInfo = {};
                itemInfo.itemIndex = Index;
                itemInfo.isForward = is_forward;
                itemInfo.content = content;

                rfDom.editRSAStr && rfDom.editRSAStr(itemInfo);
            }
        }



        
        function handleSpecialCharacters(jsonStr) {
            let obj = {};
            if (jsonStr && Object.prototype.toString.call(jsonStr) == "[object String]" && jsonStr != 'null') {
                jsonStr = jsonStr.replace(/\n/g, "\<br/>");
                obj = JSON.parse(jsonStr)
            }
            return obj;
        }
    },
    computed: {
        tagFn() {
            let tagList = this.userInfo && this.userInfo.tag_list || [];
            let _str = "";
            if(!tagList) {
                return
            }
            for(let i=0, ilen = tagList.length;i<ilen;i++) {
                _str += tagList[i].label;
                if(i < ilen - 1) {
                    _str +='、'
                }
            }
            return _str;
        },
        // 处理简介中的 @用户，高亮显示并添加点击事件
        introWithAtUser() {
            if (this.userInfo && this.userInfo.intro) {
                let intro = this.userInfo.intro;
                // 检查是否有 to_info 字段（包含 @用户的信息）
                let to_info = this.userInfo.to_info || [];

                if (to_info && to_info.length > 0) {
                    // 如果有 to_info，使用 highLightAtUser 方法
                    return highLightAtUser(intro, to_info);
                } else {
                    // 如果没有 to_info，使用正则表达式来匹配 @用户
                    // 匹配 @用户 的正则表达式（支持中文、英文、数字、下划线）
                    let atUserRegex = /@([\w\u4e00-\u9fa5]+)/g;
                    // 替换成 <a> 标签，添加 p-a-link 类名，使其能够被点击事件处理
                    let result = intro.replace(atUserRegex, '<a class="p-a-link" data-type="at_user" data-role="user" data-id="$1">$&</a>');
                    return result;
                }
            }
            return '';
        }
    },

    methods: {
        // 获取用户信息
        async getUserInfo(type) {
            let data = await userHomeApi.getTeacherInfo({
                l_id: this.l_id
            })

            if(data.rslt == 'succ') {
                data.l_id = this.l_id;
            }

            if(data.is_follow == 'no') {
                data.remark_name = "";
            }

            document.title = data.remark_name || data.title

            // data.is_vip = 'yes'; // 调试用

            this.userInfo = data;

            // 判断ID是否相同（是否为本人） - 当前登录用户以及L_id请求到的u_id是否为同一个
            if(this.u_id == data.u_id) {
                this.isSelf = true;
            } else {
                this.isSelf = false;
            }

            this.is_vip = data.is_vip;

            // 是不是会员
            // if(data.is_vip == 'yes') {
            //     this.is_show_cert_no = false;
            // } else {
            //     this.is_show_cert_no = true;
            // }

            if(type == 'reloadInfo') {
                // 获取背景图片
                this.getBackGroundImg();
            } else {
                // 获取背景图片
                this.getBackGroundImg();

                if (data.is_black != 1) {
                    // 初始化tagList
                    let tagsList = [];

                    data.tab.forEach(item => {
                        if (item.kind == "offer_msg") { // 主页、全部
                            tagsList.push({
                                title: item.name,
                                name: "TabsMsg",
                            })
                        }
                        else if (item.kind == "offer_vip_msg") { // 会员
                            tagsList.push({
                                title: item.name,
                                name: "TabsVip",
                            })
                        }
                        else if (item.kind == "offer_news") { // 专栏
                            tagsList.push({
                                title: item.name,
                                name: "TabsNews",
                            })
                        }
                        else if (item.kind == "offer_essence") { // 精华
                            tagsList.push({
                                title: item.name,
                                name: "TabsEssence",
                            })
                        }
                        // if(data.offer_qa == "yes") { // 问答
                        //     tagsList.push({
                        //         title: "问答",
                        //         name: "TabsQa",
                        //     })
                        // }
                        else if (item.kind == "offer_video") { // 视频
                            tagsList.push({
                                title: item.name,
                                name: "TabsVideo",
                            })
                        }
                        else if (item.kind == "offer_stock") { // 自选
                            this.getConsumerCombination();
                        }
                        // if(data.offer_photo == "yes") { // 相册
                        //     tagsList.push({
                        //         title: "相册",
                        //         name: "TabsImages",
                        //     })
                        // }
                    });


                    if(data.offer_combination == 'yes') {
                        // 获取模拟炒股的接口
                        this.getProfits();
                    }


                    this.tagsList = tagsList;
                    // 获取直播预告信息
                    this.getPreviewInfo();

                    // 获取直播信息
                    this.getLiveInfo();



                    // 获取模拟炒股大赛的信息
                    this.getMatchInfo();

                    // 获取聊天室信息
                    this.getChatRoomStatus();

                    // 获取战绩榜数据
                    // this.getLiverNotice();
                }
            }


            const sizeStr = data.serve_vip_top_text_image_size;
            const [width, height] = sizeStr.split('*').map(Number);
            
            this.imageStyle = {
                width: width*3.5 + 'px',
                height: height*3.5 + 'px'
            };

            this.userInfo_num.publish = this.set_num(data.releases_number);
            this.userInfo_num.follow = this.set_num(data.concerns_number);
            this.userInfo_num.praise = this.set_num(data.praised_number);
            this.userInfo_num.fans = this.set_num(data.follow_num);
            this.user_medals_tail = data.user_medals_tail;
            let APVERSION = appversion || "1160";
            if(APVERSION) {
                if(APVERSION.indexOf(".")>-1) {
                    APVERSION = APVERSION.split(".").join('')
                }
            }

            if(data.company == 'jf' && APVERSION >= 1251) {
                if(data.is_sign == 'no') {
                    this.isShowSignCard = true;
                    this.isShowSignUri = data.sign_url;
                } else {
                    if(data.is_followup == 'yes') {
                        // followup_url
                        this.$srH5CallNativeMethodApp('jump_jufeng_page', {
                            url: data.followup_url
                        })
                    } else if(data.is_satisfaction_survey == 'yes') {
                        this.isShowSatiCard = true;
                        this.isShowSatiUri = data.satisfaction_survey_url;
                    }
                }
                
            }

            if(data.company == 'zf' && APVERSION >= 1273) {
                if(data.is_sign == 'no') {
                    this.isShowSignCard = true;
                    this.isShowSignUri = data.sign_url;
                } else {
                    if(data.is_followup == 'yes') {
                        // followup_url
                        this.$srH5CallNativeMethodApp('jump_zhongfu_page', {
                            url: data.followup_url
                        })
                    } else if(data.is_satisfaction_survey == 'yes') {
                        this.isShowSatiCard = true;
                        this.isShowSatiUri = data.satisfaction_survey_url;
                    }
                }
                
            }
        },
        // 获取背景图片
        async getBackGroundImg() {
            let res = await userHomeApi.getImage({
                visit_user_id: this.userInfo.u_id
            })
            if(res.code == 0 && res.data && res.data.image) {
                this.backgroundImg = res.data.image;
            }
        },
		
		//用户个人主页  组合
		async getConsumerCombination() {
		    let data = await userHomeApi.getUserStock({
		        cuser_id: this.userInfo.u_id,
		        act: "get_stock_list",
		        format: "json",
		        type: "edit_all",
		        version: 3,
		    });
		    if (data.rslt == 'succ' && data.stock_list.length > 0) {
		        let result = data.stock_list;
		        this.stockList = result;
				
				if(result && result.length > 0) {
					this.tagsList.push({
						title: "自选",
						name: "TabsCombination"
					})	
				}
		    }
		},

        // 获取直播预告信息
        async getPreviewInfo() {
            let res = await userHomeApi.getPreviewInfo({
                room_l_id: this.l_id,
                room_u_id: this.userInfo.u_id
            })
            if(res.code == 1) {
                let result = res.data;
                if(result && result.msg && Object.keys(result.msg).length > 0 && result.msg.id) {
                    this.previewInfoo = result.msg;
                }
            }
        },

        // 获取直播信息
        async getLiveInfo() {
            let res = await userHomeApi.getLiveInfo({
                user_id: this.userInfo.u_id
            })
            if(res.code == 0 && res.status == 'success' && res.data && typeof res.data.room_id != 'undefined') {
                let result = res.data;

                // result = {
                //     duration: "已开播1分钟",
                //     is_vip_only: 0,
                //     popularity_num: 19,
                //     room_id: 1133,
                //     room_name: "测试"
                // }

                if(result && Object.keys(result.length > 0 && result.room_id)) {
                    this.liveCardInfo = result;
                }
            }
        },

        async getChatRoomStatus() {
            let res = await userHomeApi.get_chat_room_status({
                live_id: this.l_id
            });
            // 打成某种条件展示聊天室
            if(res.code == 1) {
                let result = res.data;
                if(result.chat_room_status == 1) {
                    this.chatInfo = result;
                    if(this.tagsList.find(item=>item.name == 'TabsVideo')){
                        this.tagsList.splice(-1,0,{
                            title: "聊天室",
                            name: "TabsChattingRoom"
                        })
                    }
                    else{
                        this.tagsList.push({
                            title: "聊天室",
                            name: "TabsChattingRoom"
                        })
                    }
                    
                }
            }
        },

        // 获取模拟炒股信息
        async getProfits(match_id = 0) {
            let res = await userHomeApi.getProfits({
                c_u_id: u_id, // 当前登录用户的ID
                u_id: this.userInfo.u_id, // 查看某位用户的ID
                location: "homepage", // 不知道是啥
                hs_version: "2", // 不知道是啥
                u_type: this.isSelf? '_self': '_other', // 是否为自己的
                match_id,
            })

            if(res && res.rslt == 'succ') {
                let result = res.data;
                if(match_id > 0) {
                    if(this.profitsInfo) {
                        this.initBtmLine = true;
                    }
                    result.match_id = match_id;
                    this.matchInfo = result;
                } else {
                    if(result.show_zh == '1') {
                        if(this.matchInfo) {
                            this.initBtmLine = true;
                        }
                        this.profitsInfo = result;
                    }
                }

                if(this.initBtmLine) {
                    this.$nextTick(() => {
                        this.initBtmLineFn();
                    })
                }
            }
        },

        // 获取模拟炒股大赛的信息
        async getMatchInfo() {
            // view_user_id=24
            let res = await userHomeApi.getMatchInfo({
                view_user_id: this.userInfo.u_id
            })

            if(res.code == 1) {
                let result = res.data;

                this.getProfits(result.match_id);
            }
        },

        // 获取战绩榜数据
        async getLiverNotice() {
            let res = await userHomeApi.getLiverNotice({
                location: this.tabName == 'TabsEssence' ||  true? "essence": "homepage",
                l_id: this.l_id
            })
            if(res.rslt == 'succ') {
                let result = res.data;
                if(this.tabName == 'TabsEssence') {
                    this.liverNoticeEssence = result;
                } else {
                    this.liverNoticeAll = result;
                }
            }
        },

        // 点击关注按钮
        followUserFn() {
			if(!isLoginInfo()) {
				return
			}
            // 未关注状态 -> 按钮为“关注”时
            if(this.userInfo.is_follow == 'no') {
                // 调用关注API
                this.followUser();

                // 调用推荐关注的好友列表
                this.showFollowCard = !this.showFollowCard;
            } else {
                // 通知客户端打开对话框
                // 已关注或者特别关注状态下，点击交互，弹出蒙层
                this.$srH5CallNativeMethodApp('show_cancel_follow_dialog',{
                    
                })
            }
        },

        // 点击关注用户
        async followUser(item) {
            let res = await userHomeApi.setFollowLive({
                id: this.l_id,
                act: "follow",
            })
            if(res.rslt == 'succ') {
                this.$set(this.userInfo, 'is_follow', "yes");

                this.$srH5CallNativeMethodApp('notice_live_follow',{
                    'lid': this.l_id
                })
            }
        },

        // 初始化模拟炒股大赛底部BTMLine样式
        initBtmLineFn() {
            // let RfDoms = this.$refs['user_stock_list_rf'];
            // let DefsCount = Math.ceil(RfDoms.clientWidth)
            // this.initBtmLineWidth = Math.ceil(this.pageClientWidth / DefsCount * 100);

            if(this.swiper2){
                this.swiper2.destroy(true);
            }
            this.$nextTick(() => {
                this.swiper2 = new Swiper(".swiper-container", {
                    autoplay: false,
                    freeMode: true,//滚动自由模式
                    slidesPerView: "auto",
                    initialSlide:0
                });
            });
        },

        set_num(num) {
            if (num > 10000) {
                return (num / 10000).toFixed(1) + '万';
            }
            else {
                return num;
            }
        },

        // 模拟炒股+大赛模块横向滚动方法
        userStockListScrollFn(e) {
            if(!this.initBtmLine) {
                return
            }
            let RfDoms = this.$refs['user_stock_list_rf'];
            let DefsCount = Math.ceil(RfDoms.clientWidth)
            let leftLen = Math.floor(e.target.scrollLeft / DefsCount * 100);
            if(leftLen <= 0) {
                leftLen = 0
            }
            if(leftLen >= 100) {
                leftLen = 100;
            }
            this.profitsMatchStockLeft = leftLen
        },

        // 跳转APP页面
        openNative(type, query = {}) {
            let userInfo = this.userInfo;
            let params = {
                kind: type, // 类型
            };

            // 同步传参
            params = {
                ...params,
                ...query
            }
            
            let APVERSION = appversion || "1160";
            if(APVERSION) {
                if(APVERSION.indexOf(".")>-1) {
                    APVERSION = APVERSION.split(".").join('')
                }
            }

            switch(type) {
                case "follow_page": // TA的关注
                    break;
                case "fans_page": // TA的粉丝
                    break;
                case "personal_detail": // TA的个人资料
                    break;
                case "vip_product": // 会员产品页面
					if(!isLoginInfo()) {
						return
					}
                    if(APVERSION >= 1251 && this.userInfo.company == 'jf' || (APVERSION >= 1233 && this.userInfo.company == 'zf')) {
                        params.url = `/up/app/vip_product/wap/?l_id=${this.l_id}`;
                    } else if(APVERSION < 1251 && this.userInfo.company == 'jf' || (APVERSION < 1273 && this.userInfo.company == 'zf')) {
                        const message = `<div class="vip_group_wrap_center">请升级到最新版本！</div>`
                        Dialog.alert({
                            title: '提示',
                            message,
                        }).then(() => {
                            // on close
                        });
                        return
                    } else {
                        return
                    }
                    break;
                case "direct_msg": // 私信页面
                    break;
                case "match_page": // 模拟炒股大赛 主页
                    break;
                case "match_detail_page": // 模拟炒股大赛-详情页 - 可能需要ID
                    params.id = this.matchInfo.match_id;
                    break;
                case "edit_personal_info": // 跳转编辑资料按钮
                    break;
                case "group_detail_page": // 查看某人的模拟组合页面
                    break;
                case "group_setting_page": // 模拟组合设置页面 - 应该是用户本人
                    break;
                case "group_transfer_warehousee": // 调仓页面
                    break;
                case "search_page": // 搜索页面 - 可能需要ID
                    break;
                case "medal_page":
                    // 暂时不区分
                    // ad  https://apis.aigupiao.com/MedalSystem/index&version=11.6.0
                    // ios https://apis.aigupiao.com/MedalSystem/index/u_id/77272/version/1160
                    params.url = `https://apis.aigupiao.com/MedalSystem/index/u_id/${userInfo.u_id}/version/${APVERSION}`
                    break;
                case "stock_page": // 股票详情页
                    break;
                case "theme_page": // 板块详情页
                    break;
                case "edit_background_image": // 修改背景图
                    params.img_url = this.backgroundImg
                    break;
                case "chatting_room": // 聊天室
                    params.url = `/up/app/chattingRoom/${this.l_id}`
                    break
            }

            this.$srH5CallNativeMethodApp('call_Native',params)
        },

        // 查看头像 - 图片
        viewAvatar() {
            if(this.isSelf) {
                this.$srH5CallNativeMethodApp('srBrowserMediaSelf',{
                    media: [{
                        type:'image',
                        img_url: this.userInfo.image, //图片路径
                    }]
                })
            } else {
                this.$srBrowserMedia(0,[{"type":"image","img_url": this.userInfo.image}]);
            }
        },
        handleClickTab(clickIndex) {
            // 跳转页面为聊天室
            if(clickIndex == 'TabsChattingRoom') {
                // 判断是否购买 - 已经购买的跳转-否则切换列表展示新的tab
                if(this.chatInfo.is_vip == 1 || this.chatInfo.chat_room_user_id == u_id) {
                    this.openNative('chatting_room');
                    return false
                }
            }

            this.tabName = clickIndex;
            return true;
        },
        handleChangeTab(clickIndex) {
            console.info('run_change')
            this.tabName = clickIndex;
        },
        handleScrollTab(info) {
            if(info.isFixed != this.isFixed) {
                this.isFixed = info.isFixed;
            }
        },
        columnListMore() {
            let rfDom = this.$refs[this.tabName];
            if(rfDom && rfDom.length > 0) {
                rfDom = rfDom[0];
                rfDom.columnListMore && rfDom.columnListMore();
            }
        },
        // 判断是否滚动超过一屏
        scrollGoTopFn(value) {
            if(this.isGoTop != value) {
                this.isGoTop = value;
            }
        },
        // 回到顶部
        goTop() {
            document.documentElement.scrollTop = document.body.scrollTop = 0;
        },
        // 是否关闭中讯弹窗
        closeZXTip() {
            this.zxTips = false;
        },
        listenScrollFn() {
            window.document.addEventListener(
                "scroll",
                scrollLoad(this.columnListMore),
                false
            );
            window.document.addEventListener(
                "scroll",
                scrollLoadGoTop(this.scrollGoTopFn),
                false
            )
        },
        // 点击【已关注、关注】组合按钮
        async followGroup() {
			if(!isLoginInfo()) {
				return
			}
            if(this.loading) {
                return
            }
            this.loading = true;
            let status = this.profitsInfo.is_follow;
            if(status == 'yes') {
                status = 'no';
            } else {
                status = 'yes';
            }
            
            if(u_id == this.profitsInfo.u_id && status == 'no') {
                Toast({
                    type: "html",
                    message: "<div class='stockGroupTips'>不能取消关注自己的模拟炒股</div>",
                    position: "bottom"
                })
                this.loading = false;
                return;
            }

            let res = await userHomeApi.setStockFollow({
                g_id: this.profitsInfo.u_id,
                status: status
            })
            if(res.rslt == 'succ') {
                this.$set(this.profitsInfo, 'is_follow', status);
                if(status == 'yes') {
                    Dialog.alert({
                        title: '提示',
                        message: '订阅成功，调仓记录会第一时间推送！订阅后可在“模拟炒股-我订阅的组合”中查看',
                    }).then(() => {
                        // on close
                    });
                } else {
                    Toast({
                        type: "html",
                        message: "<div class='stockGroupTips'>取消关注成功</div>",
                        position: "bottom"
                    })
                }
            }
            this.loading = false;
        },
        // 解除拉黑
        async removeBlackFn() {
			if(!isLoginInfo()) {
				return
			}
            let res = await userHomeApi.setChangeBlack({
                l_id: this.l_id,
                u_id: this.userInfo.u_id,
                l_user_id: u_id,
                kind: "blackoneid",
                type: "out"
            })

            if(res.rslt == 'succ') {
                this.getUserInfo();
            }
        },
        // 
        nickInfoFn(type, content) {
            let params = {}
            if(type == 'copy_nickname') {
                params = {
                    content: content,
                }
            } else if(type == "set_remark") {
                // 判断是否有关注
                if(this.userInfo.is_follow != 'no') {

                } else {
                    /* Dialog.alert({
                        title: '',
                        message: '请先关注该用户',
                    }).then(() => {
                        // on close
                    }); */
                    Toast({
                        type: "html",
                        message: "<div class='stockGroupTips'>请先关注该用户</div>",
                        position: "bottom"
                    })
                    return
                }
            }

            this.$srH5CallNativeMethodApp(type, params);
            this.nickInfoType = false;
        }
    },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "~@/assets/sass/global.scss";

.recommend {
    background-color: $a-list-b;
    min-height: 100vh;
}

.tabs-content {
    border-top:1px solid $a-bordr-c;
    box-sizing: border-box;
}

.user_profiles_header {
    position: relative;
    z-index: 2;
    overflow: hidden;

    .header_bg {
        position: absolute;
        top: 0;
        left: 0;
        height: calc(100% + 17px);
        width: 100%;
        z-index: -1;

        &.is_show_cert_no {
            height: 100%;
        }

        .header_bg_img {
            width: 100%;
            height: 100%;
            position: relative;

            > img {
                height: 100%;
                width: 100%;
                object-fit: cover;
                display: block;
            }

            >.transparent_box {
                width: 100%;
                height: 100%;
                background: rgba(0, 0, 0, .35);
                position: absolute;
                z-index: 1;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
            }
        }
    }

    .login_box {
        height: 28px;
        width: 100%;
        padding: 0;
    }

    .login_box_vip_top{
        display: flex;
        justify-content: center;
        margin-bottom: 10px;
    }

    .user_profiles_top {
        display: flex;
        padding: 0 12px;
        position: relative;
        z-index: 3;

        .user_image {
            width: 76px;
            height: 76px;
            border-radius: 50%;
            border: 1px solid rgba(255, 255, 255, 0.8);
            position: relative;

            >img {
                width: 100%;
                height: 100%;
                border-radius: 50%;
                display: block;
                object-fit: cover;
            }

            .icon_gender {
                position: absolute;
                bottom: 0;
                right: 0;
                width: 18px;
                height: 18px;
                z-index: 5;
                border: 1px solid #ffffff;
                border-radius: 50%;
                background-color: $a-white;

                &.male {
                    background-image: url(https://cdncos.aigupiao.com/assets/pc/img/icon-male.png);
                    background-size: 100%;
                }

                &.female {
                    background-image: url(https://cdncos.aigupiao.com/assets/pc/img/icon-female.png);
                    background-size: 100%;
                }
            }
        }

        .user_operation {
            padding-left: 12px;
            position: relative;
            
            .user_title {
                display: flex;
                height: auto;
                margin-top: 9.5px;
                align-items: left;
                flex-direction: column;
    
                .user_name {
                    font-size: 18px;
                    color: #ffffff;
                    font-weight: 600;
                    line-height: 25px;
                    user-select: none;
                }

                .nickInfoWrap {
    
                    .nickInfoWrapBg {
                        position: fixed;
                        left: 0;
                        right: 0;
                        bottom: 0;
                        top: 0;
                        background-color: rgba(0, 0, 0, .25);
                    }
    
                    .nickInfoWrapBox {
                        position: absolute;
                        left: 8px;
                        top: 50px;
                        z-index: 4;

                        & > svg {
                            width: 14.63px;
                            height: auto;
                            position: absolute;
                            z-index: 5;
                            left: 16px;
                            top: -7.3px;
                        }

                        ul {
                            background-color: #fff;
                            padding: 5px 12px;
                            box-sizing: border-box;
                            width: 109px;
                            border-radius: 6px;

                            li {
                                padding: 11px 0;
                                font-size: 14px;
                                line-height: 18px;
                                color: #333;
                                font-weight: 400;
                                border-bottom: 1px solid #ebebeb;

                                &:last-of-type {
                                    border-bottom: 0;
                                }
                            }
                        }
                    }
                }
            }
        }

        .open_vip_btn {
            position: absolute;
            right: 12px;
            width: 82px;
            height: 27px;
            border-radius: 13px;
            background-color: rgba(255, 255, 255, .20);
            background-image: url("https://cdncos.aigupiao.com/assets/app/h5/user_home/vipIco.svg");
            background-size: 28px 20px;
            background-position: 3.5px center;
            background-repeat: no-repeat;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: flex-start;
            padding-left: 34.86px;
            box-sizing: border-box;

            & > span {
                font-size: 10px;
                color: #FFF8B6;
            }

            .open_vip_btn_activity {
                /* 兼容写法 */
                animation: rotate_zy 2.5s .15s linear infinite;
                -moz-animation: rotate_zy 2.5s .15s linear infinite; /* Firefox */
                -webkit-animation: rotate_zy 2.5s .15s linear infinite; /* Safari and Chrome */
                -o-animation: rotate_zy 2.5s .15s linear infinite; /* Opera */
                position: absolute;
                right: -1px;
                top: -17px;

                span {
                    display: block;
                    width: auto;
                    height: 17px;
                    background-color: #FF892C;
                    border: 0.75px solid #fff;
                    border-radius: 2px;
                    box-sizing: border-box;
                    padding: 0 1.5px 0 3.5px;
                    color: #FFF;
                    font-size: 10px;
                    font-weight: 500;
                    line-height: 15px;
                }

                svg {
                    position: absolute;
                    right: 8px;
                    bottom: -.9px;
                    z-index: 2;
                    transform: rotate(-150deg);
                }
            }
        }

        .setBgIcon {
            width: 77px;
            height: 20px;
            background-color: transparent;
            background-image: url("https://cdncos.aigupiao.com/assets/app/h5/user_home/set_bg_icon.svg");
            background-size: 100%;
            background-position: center;
            background-repeat: no-repeat;
            margin-left: auto;
            margin-top: 20px;
        }

        .user_ip_info {
            // margin-top: 13.5px;
            display: flex;
            align-items: center;

            .user_ip {
                color: #FFF;
                text-align: right;
                font-size: 11px;
                font-style: normal;
                font-weight: 400;
                line-height: 16px;
            }
            
            &>span {
                width: 0.5px;
                height: 10px;
                flex-shrink: 0;
                background-color: $a-white;
                margin: 0 8px 0 12px;
            }

            .user_more_info {
                color: #FFF;
                font-size: 11px;
                font-style: normal;
                font-weight: 400;
                line-height: 16px;

                background-image: url('https://cdncos.aigupiao.com/assets/app/h5/user_home/right_arrow_icon.svg');
                background-repeat: no-repeat;
                background-position: right center;
                background-size: 3.5px 7px;
                padding-right: 8px;
                box-sizing: border-box;
            }
        }
    }

    .user_icons {
        display: flex;
        // padding-left: 13px;
        margin-top: 10px;

        .user_lv_icon {
            padding: 0 6px 0 8px;
            box-sizing: border-box;
            border-radius: 8.5px;
            height: 17px;
            color: #FFF;
            text-align: justify;
            font-size: 11px;
            font-style: normal;
            font-weight: 400;
            line-height: 17px; /* 109.091% */
            background: rgba(255, 255, 255, 0.20);
            margin-right: 7px;
        }

        
    
        .user_authentication_item {
            display: inline-flex;
            padding: 0 7px 0 rem2(19.5px);
            justify-content: center;
            align-items: flex-start;
            border-radius: 8.5px;
            background-color: rgba(255, 255, 255, 0.20);
            background-repeat: no-repeat;
            background-size: 10px 10px;
            background-position: 6px center;
            margin-right: 10px;
            height: 17px;

            span {
                color: #FFF;
                text-align: justify;
                font-size: 11px;
                font-style: normal;
                font-weight: 400;
                line-height: 17px; /* 109.091% */
            }
        }

        .user_open_list {
            width: 22px;
            height: 16px;
            border-radius: 8px;
            background-color: transparent;
            background-image: url("https://cdncos.aigupiao.com/assets/app/h5/user_home/top_arrow_icon.svg");
            background-size: 22px 16px;
            background-position: center;
            background-repeat: no-repeat;
            transform: rotate(-180deg);

            &.fz {
                transform: unset;
            }
        }
    }

    .user_badge {
        padding-left: 13px;

        &> div {
            margin-top: 10px;
            font-size: 12px;
            line-height: 14px;
            color: #fff;
            background-color: transparent;
            background-repeat: no-repeat;
            background-size: 10px;
            background-position: left center;
            padding-left: 15px;

            &>i {

            }
        }
    }

    .user_certificat {
        padding-left: 32px;
        box-sizing: border-box;
        margin-top: 10px;
        background-image: url("https://cdncos.aigupiao.com/assets/app/h5/user_home/certificat.svg");
        background-repeat: no-repeat;
        background-size: 14px;
        background-position: 12px center;

        &.user_certificat2{
            background-image: url("https://cdncos.aigupiao.com/assets/pc/img/2023/certificat2.png");
        }

        p {
            color: #FFF;
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: 14px; /* 116.667% */

            span {
                color: rgba(255, 255, 255, 0.80);
                font-size: 12px;
                font-style: normal;
                font-weight: 400;
                line-height: 14px; /* 116.667% */
                margin-left: 8px;
            }
        }
    }

    .user_brief {
        padding:0 12px 0 32px;
        box-sizing: border-box;
        margin-top: 8px;
        background-image: url("https://cdncos.aigupiao.com/assets/app/h5/user_home/brief.svg");
        background-repeat: no-repeat;
        background-size: 14px;
        background-position: 12px 0px;
        display: flex;
        flex-direction: row;

        &.showMargin {
            margin-top: 15px;
        }

        .user_brief_left {
            color: #FFF;
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: 14px; /* 116.667% */
        }

        .user_brief_right {
            flex: 1;
            overflow: hidden;

            p {
                color: #FFF;
                font-size: 12px;
                font-style: normal;
                font-weight: 400;
                line-height: 14px; /* 116.667% */
                overflow: hidden;
                -webkit-line-clamp: 4;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-box-orient: vertical;

                span {
                    width: 4.25px;
                    height: 7.75px;
                    display: inline-block;
                    margin-left: 5px;
                    background-color: transparent;
                    background-image: url("https://cdncos.aigupiao.com/assets/app/h5/user_home/brief_arrow.svg");
                    background-size: 100%;
                    background-repeat: no-repeat;
                    background-position: center;
                }
            }
        }
    }

    .tag_list {
        padding:0 12px 0 32px;
        box-sizing: border-box;
        margin-top: 8px;
        background-image: url("https://cdncos.aigupiao.com/assets/app/h5/user_home/style.svg");
        background-repeat: no-repeat;
        background-size: 14px;
        background-position: 12px 0;
        display: flex;
        flex-direction: row;

        .tag_list_left {
            color: #FFF;
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: 14px; /* 116.667% */
        }

        .tag_list_right {
            flex: 1;
            overflow: hidden;
            color: #FFF;
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: 14px; /* 116.667% */
        }
    }

    .blockdiv {
        display: flex;
        flex-direction: row;
        margin-top: 21px;
        padding-bottom: 19px;

        .blockdivLeft {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            padding-left: 15px;
            box-sizing: border-box;
            width: 62%;

            > dl {

                dt {
                    color: #FFF;
                    text-align: center;
                    font-size: 14px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 20px;
                }
                dd {
                    color: rgba(255, 255, 255, 0.90);
                    text-align: center;
                    font-size: 11px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 15px; 
                    margin-top: 1px;
                }
            }
        }

        .blockdivRight {
            padding: 0 12px 0 15px;
            box-sizing: border-box;
            display: inline-flex;
            flex-direction: row;
            align-items: center;
            flex: 1;

            /* 关注 */
            .blockdivFollow {
                margin-right: 12px;
                width: 79px;
                height: 33px;
                border-radius: 5px;
                border: 0.5px solid #fff;
                outline: none;
                font-size: 13px;
                font-weight: 400;
                line-height: 16px;
                text-align: center;
                color: #fff;

                /* 仅仅有一个按钮的情况下 */
                &.is_only {
                    width: 120px;
                }


                /* 未关注 */
                &.is_no_follow {
                    background-color: #F04142;
                    border: none;
                    width: 80px;

                    &.is_only {
                        width: 120px;
                    }
                }

                /* 已关注 */
                &.is_follow {
                    background-color: rgba(255, 255, 255, 0.2);
                    background-image: url("https://cdncos.aigupiao.com/assets/app/h5/user_home/follow_left_icon.svg");
                    background-repeat: no-repeat;
                    background-position: 13.5px center;
                    background-size: 9px;
                    padding: 0;
                    padding-left: 10px;
                }

                /* 特别关注 */
                &.is_special {
                    background-color: rgba(255, 255, 255, 0.2);
                    background-image: url("https://cdncos.aigupiao.com/assets/app/h5/user_home/follow_left_icon.svg");
                    background-repeat: no-repeat;
                    background-position: 7.25px center;
                    background-size: 9px;
                    padding: 0;
                    padding-left: 14px;
                }
            }

            /* 私信 */
            .blockdivMsg {
                background-color: rgba(255, 255, 255, 0.20);
                width: 54px;
                height: 33px;
                border: 0.5px solid #fff;
                outline: none;
                border-radius: 5px;
                padding: 0;
                font-size: 13px;
                font-weight: normal;
                color: #fff;
            }

            /* 编辑资料 */
            .blockdivEdit {
                background-color: rgba(255, 255, 255, 0.20);
                width: 120px;
                height: 33px;
                line-height: 33px;
                border: none;
                outline: none;
                border-radius: 5px;
                padding: 0;
                color: #FFF;
                text-align: center;
                font-size: 13px;
                font-style: normal;
                font-weight: 400;
            }
        }
    }

    /* 直播预约样式 */
    .liveInfoBox {
        height: 35px;
        border-radius: 8px;
        padding: 0 12px;
        box-sizing: border-box;
        background-color: rgba(120, 120, 128, 0.36);
        display: flex;
        flex-direction: row;
        align-items: center;
        margin: 0 13px 15px;

        .liveInfoTitle {
            padding-left: 19px;
            box-sizing: border-box;
            color: #FFD60A;
            font-size: 12px;
            font-weight: 600;
            background-image: url("https://cdncos.aigupiao.com/assets/app/h5/user_home/liveInfoTime.svg");
            background-size: 13px;
            background-repeat: no-repeat;
            background-position: left center;
        }

        .liveInfoContent {
            margin-left: 6px;
            overflow: hidden;
            color: #F3F3F3;
            text-overflow: ellipsis;
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
            flex: 1;
            white-space: nowrap;
        }

        &> span {
            margin-left: 5px;
            width: 4.25px;
            height: 7.75px;
            background-color: transparent;
            background-image: url("https://cdncos.aigupiao.com/assets/app/h5/user_home/liveInfoRightArrow.svg");
            background-size: 100%;
            background-position: center center;
            background-repeat: no-repeat;
        }
    }
}


/* 神奇的顶部圆角布局 */
.top_radius_div {
    position: relative;
    width: 100%;
    height: 1px;

    & > div {
        width: 100%;
        height: 6px;
        background-color: $a-white;
        position: absolute;
        top: -5px;
        z-index: 2;
        border-radius: 8px 8px 0px 0px;
    }
}

/* 此页面由XXX提供 */
.user_profiles_tabs_page {
    width: 100%;
    height: auto;
    box-sizing: border-box;
    background-color: $a-white;
    display: flex;
    border-bottom: 0.5px solid $a-bordr-c;
    
    &>div {
        width: 100%;
        height: auto;
        box-sizing: border-box;
        border-radius: 8px 8px 0 0;
        background-color: $a-white;
        display: inline-flex;
        padding: 4px 15px 10px 12px;
        justify-content: space-between;
        align-items: center;

        p {
            color: #AFAFAF;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
        }

        button {
            background-color: transparent;
            background-image: url("https://cdncos.aigupiao.com/assets/app/h5/user_home/top_tips_close_icon.svg");
            background-repeat: no-repeat;
            background-size: 16px 16px;
            background-position: center;
            width: 16px;
            height: 16px;
            border: none;
            padding: 0;
            margin: 0;
        }
    }
}

.swiper2{
    width: 100%;
}

.tab2.swiper2{
    .swiper-container{
        height: 100%;
    }
    .swiper-slide{
        width: auto!important;
    }
}

.hasOnly {
    .tab2.swiper2{
        .swiper-slide{
            width: 100% !important;
            box-sizing: border-box;
        }
    }
}

/* 持仓股票列表 */
.user_stock_list {
    width: 100%;
    height: auto;
    background-color: $a-white;
    padding: 6px 0 10px;
    box-sizing: border-box;
    overflow: hidden;
	border-bottom: 1px solid $a-bordr-c;

    &> div {
        width: 100%;
        height: auto;
        /* overflow-y: hidden;
        overflow-x: auto;
        touch-action: pan-x; */

        /* 单个DOM的情况下 */
        &.hasOnly {

            & > div.user_stock_list_wrap {
                height: auto;
                width: auto;
                width: 100%;
                display: inline-block;
                white-space: nowrap;
                padding:0 12px;
                box-sizing: border-box;
                width: 100%;
    
                & >  div {
                    min-width: unset;
                    width: 100%;
                    box-sizing: border-box;
                }
            }
        }

        /* 隐藏垂直滚动条 */
        &::-webkit-scrollbar {
            width: 0;
        }
        
        /* 隐藏水平滚动条 */
        &::-webkit-scrollbar {
            height: 0;
        }

        & > div.user_stock_list_wrap {
            height: auto;
            width: auto;
            width: 100%;
            display: inline-block;
            white-space: nowrap;
            padding:0 12px;
            box-sizing: border-box;

            & >  div {
                min-width: 300px;
                box-sizing: border-box;
            }
        }
    }

    &>div.user_stock_list_line {
        width: 100%;
        height: auto;
        position: relative;
        margin-top: 10px;

        & > div {
            margin: 0 auto;
            width: 30px;
            height: 2px;
            border-radius: 10px;
            background-color: #D7D7D7;
            position: relative;
            z-index: 1;
            min-width: unset;
            overflow: hidden;

            & > span {
                width: auto;
                height: 2px;
                background-color: #FF443D;
                display: block;
                position: absolute;
                z-index: 2;
                border-radius: 10px;
            }
        }
    }
    .user_stock_wrap {
        display: inline-flex;
        flex-direction: row;
        align-items: center;
        padding: 6px 10px 6px 6px;
        border-radius: 10px;
        border: 0.5px solid $a-bordr-c;
        background: $a-white3;
        box-shadow: 0 0.5px 4px 0 rgba(0, 0, 0, 0.07);

        .user_stock_left {
            width: 82px;
            height: 46px;
            border-radius: 6px;
            background-image: url("https://cdncos.aigupiao.com/assets/app/h5/user_home/top_stock_right.svg");
            background-size: 82px 46px;
            background-position: center center;
            background-repeat: no-repeat;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            position: relative;
            
            &.to_green {
                background: url(https://cdncos.aigupiao.com/assets/pc/img/bg_group_down.png);
                background-size: 100%;
            }

            &.to_red {
                background: url(https://cdncos.aigupiao.com/assets/pc/img/bg_group_up.png);
                background-size: 100%;
            }

            .user_stock_price {
                color: #FFF;
                text-align: center;
                font-size: 15px;
                font-style: normal;
                font-weight: 700;
                line-height: normal;
            }

            .user_stock_txt {
                color: #FFF;
                font-size: 12px;
                font-style: normal;
                font-weight: 400;
                line-height: normal;
            }
        }

        .user_stock_left_info {
            padding: 3px 8px 1.5px;
            box-sizing: border-box;

            .user_stock_name {
                color: $a-normal;
                font-size: 14px;
                font-style: normal;
                font-weight: 500;
                line-height: normal;
            }

            .user_stock_content {
                color: #939393;
                font-size: 12px;
                font-style: normal;
                font-weight: 400;
                line-height: normal;
                margin-top: 4.5px;
            }
        }

        .user_stock_right {
            padding: 2.75px 0.25px;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            align-items: center;
            margin-left: auto;
            
            & > .user_stock_follow {
                width: auto;
                height: 25px;
                line-height: 25px;
                box-sizing: border-box;
                border-radius: 3px;
                border: 0.5px solid #FE484A;
                display: flex;
                padding: 0 16px;
                justify-content: center;
                align-items: center;
                background-color: $a-white3;
                color: #FE484A;
                font-size: 13px;
                font-style: normal;
                font-weight: 400;

                &.is_follow {
                    border: 0.5px solid #DCDCDC;
                    color: #AFAFAF;
                }
            }

            & > .user_stock_menu {
                display: flex;
                flex-direction: row;
                align-items: center;

                button {
                    height: 26px;
                    padding: 0;
                    border: none;
                    outline: none;
                    background-color: #F4F4F4;
                    border-radius: 3px;
                }

                .user_stock_tc{
                    width: 44px;
                    color: #FE484A;
                    font-size: 13px;
                    font-style: normal;
                    font-weight: 400;
                    margin-right: 6px;
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                }

                .user_stock_set{
                    width: 26px;
                    background-image: url("https://cdncos.aigupiao.com/assets/app/h5/user_home/user_stock_set.svg");
                    background-size: 12.65px auto;
                    background-position: center;
                    background-repeat: no-repeat;
                }
            }

            & > p {
                color: #939393;
                text-align: right;
                font-size: 11px;
                font-style: normal;
                font-weight: 400;
                line-height: 16px; /* 145.455% */
                margin-top: 3px;
            }
        }
    }

    .match_stock_wrap {
        display: inline-flex;
        flex-direction: row;
        align-items: center;
        padding: 6px 10px 6px 6px;
        border-radius: 10px;
        border: 0.5px solid $a-bordr-c;
        background: $a-white3;
        box-shadow: 0px 0.5px 4px 0 rgba(0, 0, 0, 0.07);
        margin-right: 10px;

        .match_stock_left {
            width: 82px;
            height: 46px;
            border-radius: 6px;
            background-image: url("https://cdncos.aigupiao.com/assets/app/h5/user_home/top_stock_right.svg");
            background-size: 82px 46px;
            background-position: center center;
            background-repeat: no-repeat;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            &.to_green {
                background: url(https://cdncos.aigupiao.com/assets/pc/img/bg_group_down.png);
                background-size: 100%;
            }

            &.to_red {
                background: url(https://cdncos.aigupiao.com/assets/pc/img/bg_group_up.png);
                background-size: 100%;
            }

            .match_stock_price {
                color: #FFF;
                text-align: center;
                font-size: 15px;
                font-style: normal;
                font-weight: 700;
                line-height: normal;
            }

            .match_stock_txt {
                color: #FFF;
                font-size: 12px;
                font-style: normal;
                font-weight: 400;
                line-height: normal;
            }
        }

        .match_stock_left_info {
            padding: 3px 8px 1.5px;
            box-sizing: border-box;

            .match_stock_name {
                color: $a-normal;
                font-size: 14px;
                font-style: normal;
                font-weight: 500;
                line-height: normal;


                span {
                    display: inline-flex;
                    margin-left: 7px;
                    padding: 0 4px;
                    justify-content: center;
                    align-items: center;
                    border-radius: 3px;
                    border: 0.5px solid #FF4644;
                    color: #FE484A;
                    font-size: 12px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: normal;
                }
            }

            .match_stock_content {
                color: #939393;
                font-size: 12px;
                font-style: normal;
                font-weight: 400;
                line-height: normal;
                margin-top: 4.5px;
            }
        }
    }
}

/* 取消拉黑 */
.black_wrap {
    padding-top: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: #f5f6f7;

    .black_icon {
        width: 90px;
        height: 90px;
        background-color: transparent;
        background-image: url("https://cdncos.aigupiao.com/assets/app/h5/user_home/black_icon.svg");
        background-size: 100%;
        background-repeat: no-repeat;
        background-position: center;
    }

    .black_content {
        margin-top: 10px;
        font-size: 13px;
        line-height: 18px;
        color: #939393;
    }
}
.black_btn {
    background-color: $a-white;
    color: $a-normal;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100vw;
    min-width: 100%;
    text-align: center;
    padding: 0;
    height: 40px;
    line-height: 40px;
    border: none;
    font-size: 16px;
}

.user_profiles_tab_box {
    padding: 0;
    background: $a-white;

    .user_profiles_tab {
        position: relative;
        .van-tabs {
            width: 100%;
        }

        .serach_btn {
            height: 42px;
            width: 35.5px;
            box-sizing: border-box;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            margin-left: auto;
            /* position: absolute;
            z-index: 10;
            right: 0;
            top: 0;
            background-color: #fff; */

            button {
                width: 16px;
                height: 16px;
                background-color: transparent;
                background-image: url("https://cdncos.aigupiao.com/assets/app/h5/user_home/search.svg");
                background-size: 16px;
                background-repeat: no-repeat;
                background-position: center;
                border: none;
                outline: none;
            }
        }
    }
}

.loading_pop {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 10;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #f8f8f8;

    >img {
        width: 50px;
        height: 50px;
    }
}

/* 滚动到顶部 */
.scrollGoTop {
    width: 44.5px;
    height: 44.5px;
    position: fixed;
    bottom: 110px;
    right: 12px;
    background: #DADCDC;
    z-index: 5;
    border-radius: 50%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    opacity: 0.7;

    button {
        width: 100%;
        height: 100%;
        display: block;
        padding: 0;
        border: none;
        outline: none;
        background-color: transparent;
        background-image: url("https://cdncos.aigupiao.com/assets/app/h5/user_home/go_top_icon.svg");
        background-size: 44.5px;
        background-repeat: no-repeat;
        background-position: center;
    }
}


/* 左右抖动的动画 */
@-webkit-keyframes rotate_zy{ 
	10% { 
	  transform: rotate(15deg); 
	} 
	20% { 
	  transform: rotate(-10deg); 
	} 
	30% { 
	  transform: rotate(5deg); 
	} 
	40% { 
	  transform: rotate(-5deg); 
	} 
	50%,100% { 
	  transform: rotate(0deg); 
	} 
}
</style>

<style lang="scss">
@import "~@/assets/sass/global.scss";
.user_profiles_tab {
    .van-tabs {
        width: 100%;
        .van-tabs__wrap {
            height: 42px;
        }

        .van-tabs__nav{
            background: $a-white;
        }

        .van-tabs__nav--line.van-tabs__nav--complete {
            
        }

        .van-tab {
            font-size: 15px;
            color: $a-normal;
            max-width: 55px;
            padding: 0;

            span {
                overflow: unset;
            }
			
			&.van-tab--active {
				font-weight: bold;
				
				span {
					font-weight: bold;
				}
			}
        }

        .van-tabs__line {
            width: 40px;
        }
    }
}
</style>
<style lang="scss">
.dark_mode{
    .header_bg .transparent_box{
		background: rgba(0, 0, 0, .6)!important;
	}
    .user_stock_left,.theme_stock_info,.transpond_title{
        position: relative;
    }
    .tabs-content{
        >div{
            >div{
                >div{
                    background: #000!important;
                }
            }
        }
    }
    .liveCardLeft{
        position: relative;
    }
    .user_stock_left::before,.theme_stock_info::before,.stock_stock_info::before,
    .img-item::before,
    .liveCardLeft::before
    
    {
        
        content: " ";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.35);
        z-index: 1;
       
    }

    .liveCardMain2{
        box-shadow: unset!important;
        background-image: url("https://cdncos.aigupiao.com/assets/pc/img/2023/iblllllll.svg")!important;
    }

    .empty_content,
    .black_wrap,
    .loading_pop {
        filter: invert(1) hue-rotate(180deg);
    }

    .transpond_quiz_box_wrap{
        box-shadow: none!important;
    }

    .live_item .transpond_quiz_box_wrap_bs,.transpond_guess_content_new{
        background: #1E1E1E!important;
    }
    .guess_title,.transpond_list .simulation{
        color:$a-222222-F3F3F3!important;
    }
    .attention_btn{
        background: #1E1E1E!important;
    }
    .transpond_simulation_content{
        border-color: #222!important;
    }

    .charge_kaitong{
        border-color: #222!important;
    }

    .forward24{
        .transpond_special_column .transpond_box,
        .transpond_quiz_box_wrap_bs_p,
        .transpond_ordinary .transpond_ordinary_content,
        .transpond_important_news .news_bg,
        .transpond_vip_box .transpond_vip .members_only,
        .transpond_vip_box .transpond_vip .members_only .members_only_free,
        .transpond_vip_box .transpond_vip .members_only .members_only_box.zf,
        .transpond_vip_box .transpond_vip .member_brief,
        .transpond_vip_box .transpond_vip .member_pad,
        .transpond_vip_box .transpond_vip .member_news_box,
        .member_news_box .member_news{
            background: #1e1e1e;
        }
    }

    .live_item .member_news_box .member_news,
    .live_item .member_news_box .member_news .member_content_pad,
    .live_item .transpond_vote_wrap .transpond_vote_content,
    .file_wrap24{
        background: #1e1e1e!important;
        
    }
    .live_item .member_news_box .member_news .member_news_header{
        border-color: #1e1e1e!important;
    }
}
</style>
<style lang="scss">
.vip_group_wrap {
    text-align: left;
}
.vip_group_wrap_center {
    text-align: center;
}
</style>